import dates from './dates';
import booking from './booking';
import Tabs from './Tabs';

function init() {
	const bookingPage = document.querySelector('.booking-page');
	if (bookingPage) {
		if (document.documentElement.clientWidth < 768) {
			const allItems = document.querySelectorAll('.tabs__item');
			const allItemsContent = document.querySelectorAll('.tabs__item--content');
			const tabsContent = document.querySelector('.tabs__content');
			const allContent = document.querySelectorAll('.tabs__content > .container > section');

			tabsContent.innerHTML = '';

			allItems.forEach((el) => {
				el.querySelector('.tabs__item--link').addEventListener('click', () => {
					let html;

					allItemsContent.forEach((element) => {
						element.innerHTML = '';
					});

					allContent.forEach((it) => {
						if (it.className === el.getAttribute('data-target')) {
							html = String(it.innerHTML);
						}
					});

					el.querySelector('.tabs__item--content').innerHTML = html;

					booking.init();
					Tabs.init();

					if (el.getAttribute('data-target') === 'dates') {
						dates.init();
						console.log('ok');
					}
				});
			});
		}
	}
}

export default {
	init,
};
